export const common = {
  // Navigation
  home: '홈',
  curriculum: '커리큘럼',
  projects: '프로젝트',
  about: '소개',
  contact: '상담신청',
  consultation: '상담 신청',
  
  // Common buttons
  learnMore: '자세히 보기',
  getStarted: '시작하기',
  apply: '신청하기',
  submit: '제출',
  cancel: '취소',
  close: '닫기',
  
  // Company info
  companyName: 'ICAN',
  companyDescription: '우주적 사고로 미래를 준비하는 혁신적 교육 기관. 탐험하는 배움이 실제 역량으로 이어지도록 설계된 커리큘럼을 제공합니다.',
  
  // Contact info
  address: '11F and 16F Strata 100 Building\nEmerald Ave., Ortigas Center\nPasig City, Philippines',
  phone: '+632 5310 5375',
  email: 'teachers.ican@gmail.com',
  businessHours: '평일: 09:00 - 21:00\n주말: 10:00 - 18:00',
  
  // Footer
  programs: '프로그램',
  support: '지원',
  contactInfo: '연락처',
  copyright: '© 2024 ICAN Space Education. All rights reserved.',
  privacyPolicy: '개인정보처리방침',
  termsOfService: '이용약관',
  educationPolicy: '교육 정책',
  poweredBy: 'Powered by Readdy',
  certifications: '인증:',
  safeEnvironment: '안전한 교육환경',
  professionalConsultants: '전문 상담사 배치',
  certifiedProgram: '교육부 인증 프로그램',
  internationalStandard: '국제 표준 커리큘럼'
};